import { useEffect, useMemo, useCallback } from "react";
import { useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import CustomForm from "components/Common/Form";
import { DOCTOR_OPD_BILL_ITEM_FORM_CONFIG } from "./config";
import { useAlert } from "context/alert";
import zoneLocalStorageId from "utils/zone";
import Loader from "components/Common/loader";
import {
  createDoctorOpdBillPayment,
  updateDoctorOpdBillPayment,
} from "services/doctorOpdBillPaymentRouter";
import { useSelector } from "react-redux";

const AddDoctorOPDBillPaymentRouter = ({ onClose, rowData }) => {
  const {
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: useMemo(() => rowData, [rowData]),
  });

  const { user } = useSelector((state) => state.jwtAuthreducer);

  const { showAlert } = useAlert();

  const onSuccess = () => {
    const shouldRefetch = true;

    const message = rowData
      ? "Doctor OPD Bill Payment Router updated successfully!"
      : "Doctor OPD Bill Payment Router created successfully!";

    showAlert(message, "success");
    onClose(shouldRefetch);
  };

  const onError = useCallback(
    (error) => {
      const errorMessage =
        error?.response?.data?.message || "Something went wrong!";
      const errorDetail = error?.response?.data?.detail;

      showAlert(errorMessage, "danger", errorDetail);
    },
    [showAlert],
  );

  const { mutate: createDoctor, isLoading: isCreating } = useMutation({
    mutationFn: createDoctorOpdBillPayment,
    onSuccess,
    onError,
  });

  const { mutate: updateDoctor, isLoading: isUpdating } = useMutation({
    mutationFn: updateDoctorOpdBillPayment,
    onSuccess,
    onError,
  });

  const isSubmitting = isCreating || isUpdating;
  const formatTimeToHHMM = (time) => {
    if (!time) return "";
    return time.slice(0, 5);
  };

  const handleSubmitRouter = (values, e) => {
    e.preventDefault();

    console.log("values", values);

    const payload = {
      doctor_id: values?.refer_doctor_id,
      clinic_id: values?.clinic_id,
      gross_amount: Number(values?.gross_amount || 0),
      discount_amount: Number(values?.discount_amount || 0),
      tax_amount: Number(values?.tax_amount || 0),
      net_amount:
        Number(values?.gross_amount || 0) -
        Number(values?.discount_amount || 0) +
        Number(values?.tax_amount || 0),
      bill_item: values?.bill_item,
      zone_id: values?.zone_id || zoneLocalStorageId(),
      created_by:
        user?.employee_code_id || localStorage.getItem("employee_code_id"),
      is_active: values?.is_active ?? true,
    };

    if (rowData) {
      updateDoctor({
        id: rowData?.id,
        ...payload,
      });
    } else {
      createDoctor(payload);
    }

    reset();
  };

  useEffect(() => {
    reset(rowData);
  }, [rowData, reset]);

  return (
    <div style={{ position: "relative" }}>
      {isSubmitting && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(255, 255, 255, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10,
          }}
        >
          <Loader isLoading={true} />
        </div>
      )}

      <CustomForm
        config={DOCTOR_OPD_BILL_ITEM_FORM_CONFIG(rowData)}
        onSubmit={handleSubmitRouter}
        columnCount={2}
        rowData={rowData}
        disabled={isSubmitting}
      />
    </div>
  );
};

export default AddDoctorOPDBillPaymentRouter;
